const columns = [
    {
      title: 'Account No',
      dataIndex: 'terminalID',
    },
    {
      title: 'A/C Type',
      dataIndex: 'planName',
    },
    {
      title: 'Balance',
      dataIndex: 'balance',
    },
    {
      title: 'Leverage',
      dataIndex: 'leverage',
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
    },
  ];
  
  export default columns;